// extracted by mini-css-extract-plugin
export var copyableField = "_qt-4";
export var customerBadge = "_qt-0";
export var customerInfoTitle = "_qt-2";
export var details = "_qt-1";
export var dropdownContainer = "_qt-5";
export var dropdownImage = "_qt-6";
export var editAssigneeForm = "_qt-a";
export var editButton = "_qt-3";
export var email = "_qt-7";
export var hidden = "_qt-d";
export var input = "_qt-8";
export var saveButton = "_qt-b";
export var shopifyIcon = "_qt-c";
export var suggestionBadge = "_qt-e";
export var suggestionText = "_qt-f";
export var username = "_qt-9";